import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DatosService,crearReportPagos } from 'src/app/services/DatosService.service';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx'
import { HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-pagos-report',
  templateUrl: './pagos-report.component.html',
  styleUrls: ['./pagos-report.component.css']
})
export class PagosReportComponent implements OnInit  {
reporte:crearReportPagos={

  aspirantesx:false,
  inscripcionx: false,
    reinscripcionx:false,
  otrosconceptosx:false,
  plantel: null,
  fachaini: ' ',
      fechafin:' ',


  };

  Aspirantes:boolean=false;
  Inscripcion: boolean = false;
  Reinscripcion: boolean = false;
Otrosconceptos: boolean = false;
  todos:boolean=false;

  datosAspirante:any=[];
  datosInscripcion: any = [];
  datosReinscripcion:any=[];
  datosOtros:any=[];
  periodos:any=[];
  planteles:any=[];
  getdocentes: any = [];
  
  datos: any = [];
    datos1: any = [];
    datos2: any = [];
  datosReporteAsigySub:any[];
  datosReporteExtracurriculares:any[];

  API_URI = environment.uri_api;

  numplantel:number;
  nombreplantel:number;
  verinputplantel:boolean=false;
  vercomboplantel:boolean=false;

  constructor( private traer:DatosService,private msj:mensajeSesionExpiradaService,private router:Router) { }

  ngOnInit(): void {

    let datos = JSON.parse(localStorage.getItem('datos'));
    this.numplantel=datos.idplantel;
   

    if(this.numplantel==0){

      this.verinputplantel=false;
      this.vercomboplantel=true;

      this.getplanteles();

    }else if(this.numplantel != 0){

      this.nombreplantel=datos.idplantel;
      this.verinputplantel=true;
      this.vercomboplantel=false;

      this.reporte.plantel=this.numplantel;
      this.nombreplantel=datos.plantel;
      console.log(this.reporte.plantel);
    }

    this.getperiodos();

  }

  testCheckAspirantes(event:any){
    console.log(event.target.checked); 
    this.Aspirantes= event.target.checked;

    if(this.Aspirantes==true){


    }else if(this.Aspirantes==false){
      this.todos=false;
    }

  }

  testCheckInscripcion(event:any){
    console.log(event.target.checked); 
    this.Inscripcion= event.target.checked;

    if(this.Inscripcion==true){


    }else if(this.Inscripcion==false){
      this.todos=false;
    }

  }

  testCheckReinscripcion(event:any){
    console.log(event.target.checked); 
    this.Reinscripcion= event.target.checked;

    if(this.Reinscripcion==true){


    }else if(this.Reinscripcion==false){
      this.todos=false;
    }

  }

    testCheckOtrosconceptos(event:any){
    console.log(event.target.checked); 
    this.Otrosconceptos= event.target.checked;

    if(this.Otrosconceptos==true){


    }else if(this.Otrosconceptos==false){
      this.Otrosconceptos=false;
    }

  }





  testCheckTodos(event:any){
    console.log(event.target.checked);
    this.todos= event.target.checked;

    if(this.todos==true){
      
    this.reporte.aspirantesx=true;
      this.reporte.inscripcionx = true;
          this.reporte.reinscripcionx=true;
    this.reporte.otrosconceptosx=true;

    }else{
      
    this.reporte.aspirantesx=false;
      this.reporte.inscripcionx = false;
          this.reporte.reinscripcionx=false;
    this.reporte.otrosconceptosx=false;

    }

  }



  Reporte(form:NgForm){

    if(this.reporte.aspirantesx==false && this.reporte.inscripcionx==false && this.reporte.reinscripcionx==false && this.reporte.otrosconceptosx==false && this.todos==false){
      Swal.fire({

        title:"Información incompleta",
        icon:"warning",
        text:'Elija una opción de reporte'
  
      })
    }else{

      if(this.todos==true){

        this.ejecutarTodos();
        return;
      }
        else if (this.todos==false && (this.reporte.aspirantesx == true && this.reporte.inscripcionx == true && this.reporte.reinscripcionx == false && this.reporte.otrosconceptosx == false) || (this.reporte.aspirantesx == true && this.reporte.reinscripcionx == true && this.reporte.inscripcionx == false && this.reporte.otrosconceptosx == false) || (this.reporte.aspirantesx == true && this.reporte.otrosconceptosx == true && this.reporte.inscripcionx == false && this.reporte.reinscripcionx == false) || (this.reporte.inscripcionx == true && this.reporte.reinscripcionx == true && this.reporte.aspirantesx == false && this.reporte.otrosconceptosx == false) || (this.reporte.inscripcionx == true && this.reporte.otrosconceptosx == true && this.reporte.aspirantesx == false && this.reporte.reinscripcionx == false) || (this.reporte.reinscripcionx == true && this.reporte.otrosconceptosx == true && this.reporte.inscripcionx == false && this.reporte.aspirantesx == false)){

        this.ejecutarDos();
        return;
      }

         else if (this.todos==false && (this.reporte.aspirantesx == true && this.reporte.inscripcionx == true) || (this.reporte.aspirantesx == true && this.reporte.reinscripcionx == true) || (this.reporte.aspirantesx == true && this.reporte.otrosconceptosx == true) || (this.reporte.inscripcionx == true && this.reporte.reinscripcionx == true) || (this.reporte.inscripcionx == true && this.reporte.otrosconceptosx == true) || (this.reporte.reinscripcionx == true && this.reporte.otrosconceptosx == true)){

        this.ejecutarTres();
        return;
      }

    if(form.valid ){

      Swal.fire({
        title: "Esta operación podría tomar algun tiempo",
        text: "¡Por favor sea paciente!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok, entendido",
        cancelButtonText:"Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {  

    this.traer.http.post(this.API_URI+'/generarExcelPagos',this.reporte)
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.datosAspirante=res.datos;

      console.log(this.datosAspirante);
    
        let arr = this.datosAspirante;
      
      let Heading = [['Linea de captura', 'Nombre', 'Clave del plantel','Nombre del plantel','Monto','Derecho','Estatus','Establecimiento','Concepto de pago','Fecha de pago','Generado']];
    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);

   
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A2', skipHeader: true });

    
         var wscols = [
            {wch:23,}, //
            {wch:30}, //
            {wch:15}, //
            {wch:16},  //
            {wch:8}, //
            {wch:8}, //
            {wch:8}, //
            {wch:15}, //
            {wch:100}, //
            {wch:30}, //
            {wch:10}, //
            
        ];
        
        ws['!cols'] = wscols;
      if (this.reporte.aspirantesx == true && this.reporte.inscripcionx == false  && this.reporte.reinscripcionx == false && this.reporte.otrosconceptosx == false) {
        XLSX.utils.book_append_sheet(wb, ws, 'Aspirantes', true);
      }
           else if (this.reporte.aspirantesx == false && this.reporte.inscripcionx == true  && this.reporte.reinscripcionx == false && this.reporte.otrosconceptosx == false) {
        XLSX.utils.book_append_sheet(wb, ws, 'Inscripción', true);
            }
           else if (this.reporte.aspirantesx == false && this.reporte.inscripcionx == false  && this.reporte.reinscripcionx == true && this.reporte.otrosconceptosx == false) {
        XLSX.utils.book_append_sheet(wb, ws, 'Reinscripción', true);
            }
           else if (this.reporte.aspirantesx == false && this.reporte.inscripcionx == false  && this.reporte.reinscripcionx == false && this.reporte.otrosconceptosx == true) {
        XLSX.utils.book_append_sheet(wb, ws, 'Otros Conceptos', true);
      }
      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

      }
    });


    }
    else {
    Swal.fire({

      title:"Información incompleta",
      icon:"error",
      text:'Complete los campos'

    })
    }

    }
    

  }

  getperiodos(){

    var t=localStorage.getItem('token');
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    this.traer.http.get(this.API_URI+'/getPeriodos',{headers:httpHeaders})
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.periodos=res;
    });

  }

  getplanteles(){

    var t=localStorage.getItem('token');
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    this.traer.http.get(this.API_URI+'/getPlanteles',{headers:httpHeaders})
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

console.log(res); 
res.shift();
      this.planteles=res;
    });

  }



  ejecutarTodos(){

        Swal.fire({
      title: "Esta operación podría tomar algun tiempo",
      text: "¡Por favor sea paciente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok, entendido",
      cancelButtonText:"Cancelar"
    }).then((result) => {

      if (result.isConfirmed) {

    this.traer.http.post(this.API_URI+'/generarExcelPagosTodos',this.reporte)
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion(); 
        return;  
    }

      this.datosAspirante=res.aspirante;
      this.datosInscripcion = res.inscripcion;
      this.datosReinscripcion=res.reinscripcion;
      this.datosOtros=res.otrosconceptos;

    
        let arr = this.datosAspirante;
        let arr1 = this.datosInscripcion;
        let arr2=this.datosReinscripcion;
        let arr3=this.datosOtros;
      
      let Heading = [['Linea de captura', 'Nombre', 'Clave del plantel','Nombre del plantel','Monto','Derecho','Estatus','Establecimiento','Concepto de pago','Fecha de pago','Generado']];

    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);

      const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws2, Heading);

      const ws3: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws3, Heading);

      const ws4: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws4, Heading);
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A2', skipHeader: true });
      XLSX.utils.sheet_add_json(ws2, arr1, { origin: 'A2', skipHeader: true });
      XLSX.utils.sheet_add_json(ws3, arr2, { origin: 'A2', skipHeader: true });
      XLSX.utils.sheet_add_json(ws4, arr3, { origin: 'A2', skipHeader: true });
         var wscols = [
            {wch:23,}, //
            {wch:30}, //
            {wch:15}, //
            {wch:16},  //
            {wch:8}, //
            {wch:8}, //
            {wch:8}, //
            {wch:15}, //
            {wch:100}, //
            {wch:30}, //
            {wch:10}, //
           
        ];


        
        ws['!cols'] = wscols;
        ws2['!cols'] = wscols;
        ws3['!cols'] = wscols;
        ws4['!cols'] = wscols;
    
      XLSX.utils.book_append_sheet(wb, ws, 'Aspirantes',true);
      XLSX.utils.book_append_sheet(wb, ws2, 'Inscripción',true);
      XLSX.utils.book_append_sheet(wb, ws3, 'Reinscripción',true);
      XLSX.utils.book_append_sheet(wb, ws4, 'Otros conceptos', true);
      
      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

  }

});

  }


  ejecutarDos(){

        Swal.fire({
      title: "Esta operación podría tomar algun tiempo",
      text: "¡Por favor sea paciente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok, entendido",
      cancelButtonText:"Cancelar"
    }).then((result) => {

      if (result.isConfirmed) {

    this.traer.http.post(this.API_URI+'/generarExcelPagos',this.reporte)
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.datos=res.datos;
      this.datos1=res.datos1;

    
        let arr = this.datos;
        let arr1=this.datos1;
      
      let Heading = [['Linea de captura', 'Nombre', 'Clave del plantel','Nombre del plantel','Monto','Derecho','Estatus','Establecimiento','Concepto de pago','Fecha de pago','Generado']];
    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);

      const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws2, Heading);

      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A2', skipHeader: true });
      XLSX.utils.sheet_add_json(ws2, arr1, { origin: 'A2', skipHeader: true });
    
         var wscols = [
            {wch:23,}, //
            {wch:30}, //
            {wch:15}, //
            {wch:16},  //
            {wch:8}, //
            {wch:8}, //
            {wch:8}, //
            {wch:15}, //
            {wch:100}, //
            {wch:30}, //
            {wch:10}, //
        ];


        
        ws['!cols'] = wscols;
        ws2['!cols'] = wscols;
    
      XLSX.utils.book_append_sheet(wb, ws, res.dato,true);
      XLSX.utils.book_append_sheet(wb, ws2, res.dato1,true);
      
      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

  }

});

  }

    ejecutarTres(){

        Swal.fire({
      title: "Esta operación podría tomar algun tiempo",
      text: "¡Por favor sea paciente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok, entendido",
      cancelButtonText:"Cancelar"
    }).then((result) => {

      if (result.isConfirmed) {

    this.traer.http.post(this.API_URI+'/generarExcelPagos',this.reporte)
    .subscribe((res:any)=>{

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.datos=res.datos;
      this.datos1=res.datos1;
      this.datos2=res.datos2;
    
        let arr = this.datos;
        let arr1=this.datos1;
      let arr2 = this.datos2;
      
      let Heading = [['Linea de captura', 'Nombre', 'Clave del plantel','Nombre del plantel','Monto','Derecho','Estatus','Establecimiento','Concepto de pago','Fecha de pago','Generado']];
    
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws, Heading);

      const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws2, Heading);

            const ws3: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_aoa(ws3, Heading);
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, arr, { origin: 'A2', skipHeader: true });
      XLSX.utils.sheet_add_json(ws2, arr1, { origin: 'A2', skipHeader: true });
          XLSX.utils.sheet_add_json(ws3, arr2, { origin: 'A2', skipHeader: true });

         var wscols = [
            {wch:23,}, //
            {wch:30}, //
            {wch:15}, //
            {wch:16},  //
            {wch:8}, //
            {wch:8}, //
            {wch:8}, //
            {wch:15}, //
            {wch:100}, //
            {wch:30}, //
            {wch:10}, //
        ];


        
        ws['!cols'] = wscols;
        ws2['!cols'] = wscols;
            ws3['!cols'] = wscols;

      XLSX.utils.book_append_sheet(wb, ws, res.dato,true);
      XLSX.utils.book_append_sheet(wb, ws2, res.dato1,true);
            XLSX.utils.book_append_sheet(wb, ws3, res.dato2,true);

      XLSX.writeFile(wb,res.tipolista+'.xlsx');


    })

  }

});

  }

}